import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageUtil {

  save(tokenResponse: string): void {
    sessionStorage.setItem('accessToken', tokenResponse || '');
  }

  get(): string | null {
    return sessionStorage.getItem('accessToken');
  }

  clear(): void {
    sessionStorage.removeItem('accessToken');
  }
  
}
